// One validity guard shared by every report renderer. An INP value of zero is
// not a fast interaction: it is the sentinel emitted when no valid Event
// Timing interaction was captured.
export const hasValidInpMeasurement = (result) => {
  if (!result || result.success === false) return false;
  if (result.noValidInteraction === true || result.interactionMeasured === false) return false;
  if (result.valid === false || result.invalid === true) return false;
  if (result.attributionValid === false || result.targetsFound === 0) return false;
  return Number.isFinite(Number(result.inp)) && Number(result.inp) > 0;
};